// @core/api/endpoints/team/update_team_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  UpdateTeamRoleRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Update team role
 * Updates a custom team role's name, description, or permissions. Changes apply immediately to all members with this role.
 */
export async function UpdateTeamRole(
  team_id: string,
  role_id: string,
  data: UpdateTeamRoleRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/roles/:role_id`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  requestPath = requestPath.replace(':role_id', encodeURIComponent(role_id));
  const requestOptions = options;
  return client.put<Response>(requestPath, data, requestOptions);
}
